import ClientWrap from './ClientWrap';

export default ClientWrap;
